import React from 'react';
import { CssBaseline, Box, Container, Grid } from '@mui/material';
import Banner from '../Layout/Banner';
import ReplySection from './ReplySection';

function Reply() {
  const url = `${process.env.REACT_APP_STATIC_URL}/uploads/banner/banner_hoiam.png`;
  const title = 'HỒI ÂM'
  return (
    <Box>
      <CssBaseline />
      <Banner
        url={url}
        title={title}
      />
      <ReplySection></ReplySection>
    </Box>
  );
}

export default Reply;